import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableSearch'
})
export class TableSearchPipe implements PipeTransform {
  filter;

  transform(items: any[], searchValue: string, filterOptions: [string]): any {
    if (!items || !searchValue || !filterOptions){
      return items;
    }

    let reg = new RegExp(searchValue, 'ig');

    return items.filter( item => {
      return filterOptions
        .filter( key => item[key] && item[key].match( reg ) )
        .length > 0
    });
  }

}

